import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "Header A1",
  "component": "header"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "header-a1"
    }}>{`Header A1`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<header
  sx={{
    display: 'flex',
    alignItems: 'center',
    variant: 'styles.header',
  }}>
  <Link
    to="/"
    sx={{
      variant: 'styles.navlink',
      p: 2,
    }}>
    Hello
  </Link>
  <div sx={{ mx: 'auto' }} />
  <Link
    to="/blog"
    sx={{
      variant: 'styles.navlink',
      p: 2,
    }}>
    Blog
  </Link>
  <Link
    to="/about"
    sx={{
      variant: 'styles.navlink',
      p: 2,
    }}>
    About
  </Link>
</header>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      